import PromoButton from '../PromoButton/PromoButton';

const HREF = 'https://www.bitunix.com/register?vipCode=tradermap';

export default function BitunixPromo({ shape = 'round', className }) {
  return (
    <PromoButton
      href={HREF}
      accent="#c3f53c"
      shape={shape}
      prefix="Trade on"
      brand="Bitunix"
      badge={{ full: '$150 BONUS - NON KYC', short: '$150 NON KYC', tiny: '$150' }}
      className={className}
    />
  );
}
